import { render, staticRenderFns } from "./ContratosTabela.vue?vue&type=template&id=cf6caa2a&lang=pug"
import script from "./ContratosTabela.vue?vue&type=script&lang=js"
export * from "./ContratosTabela.vue?vue&type=script&lang=js"
import style0 from "./ContratosTabela.vue?vue&type=style&index=0&id=cf6caa2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports